import { inventoryDetailsApi } from "@/services/api/inventoryDetails.api";

export const inventoryDetailsState = {
  state: {
    items: [],
    totalItem: 0,
    total: 0,
    loading: true,
    fetching: false,
    error: "",
  },
  mutations: {
    INVENTORY_ITEMS_FETCH_SUCCESS(state, payload) {
      state.items = payload.data;
      state.total = payload.data.length;
      state.totalItem = payload.totalCount;
      state.loading = false;
      state.fetching = false;
    },
    INVENTORY_ITEMS_FETCH_START(state) {
      state.fetching = true;
    },
    INVENTORY_ITEMS_FETCH_ERROR(state, payload) {
      state.fetching = false;
      state.error = payload;
    },
  },
  actions: {
    getInventoryItems(context, request) {
      context.commit("INVENTORY_ITEMS_FETCH_START");

      const promise = new Promise( (resolve, reject) => {
        inventoryDetailsApi
        .getAll(request)
        .then(response => {
          context.commit("INVENTORY_ITEMS_FETCH_SUCCESS", response.data);
          resolve(response);
        })
        .catch(error => {
          context.commit("INVENTORY_ITEMS_FETCH_ERROR", error);
          reject(error);
        });
      });
      return promise;
    },
  },
};
